import { useActionState, useEffect, useState } from "react";
import { Charity, CharityIssue } from "../../../../models";
import { Button } from "../../../../components/button";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
import CharityIssueCharityService from "../../../../services/CharityIssueCharityService";
import toast from "react-hot-toast";
import IconButton from "../../../../components/icon-button";
import { CheckIcon, PlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import {
  createCharityIssueCharity,
  State,
  updateCharityIssueCharity,
} from "../actions/CharityIssueCharity";
import { useNavigate } from "react-router-dom";
import FormError from "../../../../components/form-error";
import Select from "../../../../components/select";
import CharityIssueCharityViewModel from "../../../../viewModels/CharityIssueCharityViewModel";

export default function CharityIssueCharityEditForm({
  charity,
  charityIssues,
  charityIssueCharity,
  onCancel,
}: {
  charity: Charity;
  charityIssues: CharityIssue[];
  charityIssueCharity: CharityIssueCharityViewModel;
  onCancel: () => void;
}) {
  const navigate = useNavigate();
  const api = new CharityIssueCharityService();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      incidence: charityIssueCharity.incidence,
    },
  };
  const [state, formAction, isPending] = useActionState(
    updateCharityIssueCharity.bind(null, charityIssueCharity.id || 0),
    initialState
  );
  useEffect(() => {
    if (state.success) {
      toast.success("Charity Issue updated successfully");
      navigate(`/admin/charities/edit/${charity.id}?reload=${Date.now()}`);
      onCancel();
    }
  }, [state]);

  return (
    <form className="flex flex-1 flex-col " action={formAction}>
      <div className="flex flex-1 gap-2 items-end">
        <div className="flex flex-row gap-2">
          <Select
            id="charityIssueId"
            name="charityIssueId"
            placeholder="Select charity issue"
            items={charityIssues.map((charityIssue) => ({
              id: charityIssue.id,
              name: charityIssue.name,
            }))}
            required
            className="w-full"
            defaultValue={charityIssueCharity.charityIssueId}
          ></Select>
          <div   style={{maxWidth:250}} className="w-full">
          <Input
            id="incidence"
            name="incidence"
            type="number"
            step="0.01"
            min="0"
            placeholder="Enter incidence amount"
            required
            className="max-w-64"
            defaultValue={charityIssueCharity.incidence}
          
          />
          </div>
          <input
            type="hidden"
            id="charityId"
            name="charityId"
            value={charity.id}
          />
        </div>
        <IconButton
          label="Update Charity Issue"
          icon={CheckIcon}
          loading={isPending}
        ></IconButton>
        <IconButton
          label="Cancel"
          icon={XMarkIcon}
          onClick={onCancel}
        ></IconButton>
      </div>
      <FormError id="incidence-error" message={state.errors?.incidence} />
    </form>
  );
}
